import { createAction, props } from '@ngrx/store';
import { IContainerSearchState } from './container.reducer';

export const containerSearchInitiated = createAction(
    '[Container Search Component] Search Initiated',
    props<IContainerSearchState>()
);